import Icon from '@/components/shared/icons'
import DateConvert from '@/utils/date-convert'
import entityConvert from '@/utils/entity-convert'
import { Badge, Box, Flex, Heading, Text } from '@chakra-ui/react'
import Toast from '../elements/toast'
import { removeCategoryById } from '@/services/api/categories/categories'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@/store/store'
import { deleteCategoryFn } from '@/store/features/categories'
import { ToastConfirm } from '../elements/toast-confirm'
import { sessionRefrestUpdate } from '@/store/features/state'
import CategoriesEntity from '@/entities/api/categories/categories'

const CategoryCard = ({
	click,
	category,
	token,
}: {
	click: () => void
	category: CategoriesEntity
	token: string
}) => {
	const dispatch = useDispatch<AppDispatch>()

	const removeCategoryFn = async (category: CategoriesEntity) => {
		try {
			ToastConfirm({
				message: '¿Quieres eliminar este elemento?',
				onConfirm: async () => {
					const response = await removeCategoryById(token, category?._id ?? '')

					if (response?.status === 500 || response?.status === 404) {
						Toast({
							type: 'error',
							message: 'No se pudo eliminar la categoria',
						})
						return
					}

					if (response?.status === 401) {
						Toast({
							type: 'info',
							message: 'La session del usuario a expirado',
						})
						dispatch(sessionRefrestUpdate())
						return
					}

					dispatch(deleteCategoryFn(category._id ?? ''))
					Toast({
						type: 'success',
						message: 'Se elimino correctamente la categoria',
					})
				},
				onCancel: () => {
					Toast({
						type: 'info',
						message: 'Se cancelo la operacion',
					})
				},
				confirmLabel: 'Eliminar',
				cancelLabel: 'Cancelar',
			})
		} catch (error) {
			Toast({ type: 'error', message: 'No se pudo eliminar la categoria' })
		}
	}

	return (
		<Box
			bg='white'
			borderRadius='md'
			p='3'
			shadow='sm'
			maxW='xs'
			cursor='pointer'
			position='relative'
		>
			<Box position='absolute' top='1' right='1' zIndex='3'>
				<Icon
					icon='delete'
					click={() => removeCategoryFn(category)}
					size='sm'
					color='black'
				/>
			</Box>
			<Flex flexDirection='column' alignItems='center' onClick={click}>
				<Text fontSize='xs' fontWeight='200' color='gray.500' mb={3}>
					{DateConvert(category?._created ?? 'Sin fecha')}
				</Text>

				<Heading
					as='h3'
					fontSize='md'
					fontWeight='700'
					color='black'
					textAlign='center'
					wordBreak='break-word'
					whiteSpace='normal'
				>
					{category?.name ?? 'Sin nombre'}
				</Heading>

				<Badge
					bg='gray.50'
					color='black'
					p={1.5}
					borderRadius='full'
					fontSize='xs'
					display='flex'
					alignItems='center'
					justifyContent='center'
				>
					<Icon icon={category?.type} size='lg' color='gray.600' />
					{entityConvert(category?.type)}
				</Badge>
			</Flex>
		</Box>
	)
}

export default CategoryCard
